export const ROUTE_NAMES = {
  account: 'account',
  accountChangePassword: 'account-change-password',
  accountEmailConfirm: 'account-email-confirm',
  accountEmailConfirmed: 'account-email-confirmed',
  accountForgotPassword: 'account-forgot-password',
  accountRegistrationAgents: 'account-registration-agents',
  accountRegistrationRepreses: 'account-registration-represes',
  accountRegistrationStepsAccepted: 'account-registration-steps-accepted',
  accountRegistrationStepsReglament: 'account-registration-steps-reglament',
  accountReglament: 'account-reglament',
  accountSetPassword: 'account-set-password',
  acts: 'acts',
  agents: 'agents',
  agentsId: 'agents-id',
  agentsIdFire: 'agents-id-fire',
  apartmentCatalog: 'apartment-catalog',
  calendar: 'calendar',
  calendarId: 'calendar-id',
  choiceApartment: 'choice-apartment',
  choiceApartmentCatalog: 'choice-apartment-catalog',
  choiceApartmentCatalogCity: 'choice-apartment-catalog-city',
  choiceApartmentChessboard: 'choice-apartment-chessboard',
  choiceApartmentChessboardProject: 'choice-apartment-chessboard-project',
  choiceApartmentProject: 'choice-apartment-project',
  clients: 'clients',
  clientsId: 'clients-id',
  closedSales: 'closed-sales',
  collectionCreate: 'collection-create',
  collectionManager: 'collection-manager',
  collectionManagerId: 'collection-manager-id',
  collectionRecent: 'collection-recent',
  collectionRecentId: 'collection-recent-id',
  collections: 'collections',
  deals: 'deals',
  dealsId: 'deals-id',
  dealsIdBooking: 'deals-id-booking',
  dealsIdCatalog: 'deals-id-catalog',
  documents: 'documents',
  documentsId: 'documents-id',
  faq: 'faq',
  fired: 'fired',
  forgotPasswordEmailed: 'forgot-password-emailed',
  index: 'index',
  interaction: 'interaction',
  knowbase: 'knowbase',
  legalDocuments: 'legal-documents',
  legalDocumentsSlug: 'legal-documents-slug',
  linkExpired: 'linkExpired',
  login: 'login',
  loyaltyProgram: 'loyalty-program',
  news: 'news',
  newsPromoSlug: 'news-promo-slug',
  newsSlug: 'news-slug',
  printCommercialOfferId: 'print-commercial-offer-id',
  printLegalDocument: 'print-legal-document',
  profile: 'profile',
  profileFireSelectDeals: 'profile-fire-select-deals',
  profileRegistration: 'profile-registration',
  quiz: 'quiz',
  registrationPersonal: 'registration-personal',
  tekhnoklasterMolzhaninovoMega: 'tekhnoklaster-molzhaninovo-mega',
  uploadDocuments: 'upload-documents',
} as const;

export const ROUTE_PATHS = {
  account: '/account',
  accountAgentsForgotPassword: '/account/agents/forgot-password',
  accountForgotPassword: '/account/forgot-password',
  accountRegistrationAgents: '/account/agents/registration',
  accountRegistrationRepreses: '/account/represes/registration',
  accountRepresesForgotPassword: '/account/represes/forgot-password',
  acts: '/acts',
  agents: '/agents',
  apartmentCatalog: '/apartment-catalog',
  calendar: '/calendar',
  choiceApartmentCatalog: '/choice-apartment/catalog',
  choiceApartmentCatalogCity: '/choice-apartment/strana-city',
  choiceApartmentChessboard: '/choice-apartment/chessboard',
  clients: '/clients',
  closedSales: '/closed-sales',
  collectionCreate: '/collections/create',
  collectionManager: '/collections/manager',
  collectionRecent: '/collections/recent',
  collections: '/collections',
  deals: '/deals',
  documents: '/documents',
  faq: '/faq',
  fired: '/fired',
  forgotPasswordEmailed: '/account/forgot-password-emailed',
  index: '/',
  interaction: '/interaction',
  knowbase: '/knowbase',
  legalDocuments: '/legal-documents',
  linkExpired: '/errors/link-expired',
  login: '/login',
  loyaltyProgram: '/loyalty-program',
  news: '/news',
  printLegalDocument: '/print/legal-document',
  profile: '/profile',
  profileFireSelectDeals: '/profile/fire/select-deals',
  profileRegistration: '/profile/registration',
  tekhnoklasterMolzhaninovoMega: '/tekhnoklaster-molzhaninovo-mega',
};
